import { makeStyles } from 'tss-react/mui';

const useStylesTableRowSubgroupHeader: MaterialUIStylesCallback = makeStyles()((
  theme: MainTheme,
): MaterialUIStyles => ({
  tableRowSubgroupHeader: {
    '& > td': {
      background: `${theme.palette.info.main} !important`,
      color: theme.palette.common.black,
    },
  },
}));

export default useStylesTableRowSubgroupHeader;
